import { dateTimeFormatter, type Locale } from "@opensea/i18n"
import type { TickMarkFormatter } from "lightweight-charts"
import { TickMarkType } from "lightweight-charts"

export const tickMarkFormatter: TickMarkFormatter = (
  time,
  tickMarkType,
  locale,
) => {
  const formatter = dateTimeFormatter(locale as Locale)
  const seconds = Number(time)
  const date = new Date(seconds * 1000)
  switch (tickMarkType) {
    case TickMarkType.Time:
      return formatter(date, {
        display: "custom",
        hour: "numeric",
        minute: "numeric",
      })
    case TickMarkType.DayOfMonth:
      return formatter(date, {
        display: "custom",
        day: "numeric",
        month: "short",
      })
    case TickMarkType.Month:
      return formatter(date, { display: "custom", month: "short" })
    case TickMarkType.TimeWithSeconds:
      return formatter(date, {
        display: "custom",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      })
    case TickMarkType.Year:
      return formatter(date, { display: "custom", year: "numeric" })
    default:
      return formatter(date, { display: "date-numeric" })
  }
}
